import { Dispatch, SetStateAction, useState } from 'react';
import * as yup from 'yup';
import { HospitalBank } from 'types/hospital';

export type HospitalBankValidation = {
  bank_name?: string;
  account_holder?: string;
  operation?: string;
  pix_key?: string;
  pix_key_type?: string;
  bank_account?: string;
  bank_agency?: string;
};

type UseHospitalBankValidation = [
  HospitalBankValidation,
  Dispatch<SetStateAction<HospitalBankValidation>>,
  (bank: HospitalBank) => Promise<void>,
];

export function useHospitalBankValidation(): UseHospitalBankValidation {
  async function handleValidation(bank: HospitalBank) {
    const schema = yup.object().shape({
      operation: yup.string().required('A operação é obrigatória'),
      pix_key: yup.string().required('A chave PIX é obrigatória'),
      pix_key_type: yup.string().required('O tipo da chave PIX é obrigatório'),
      bank_account: yup.string().required('A conta bancária é obrigatória'),
      bank_agency: yup.string().required('A agência bancária é obrigatória'),
      account_holder: yup.string().required('O nome do titular da conta é obrigatório'),
      bank_name: yup.string().required('O nome do banco é obrigatório'),
    });

    try {
      await schema.validate(bank);
    } catch (err) {
      const error = err as yup.ValidationError;
      if (error.path && error.message) {
        setValidation({
          [error.path]: error.message,
        });
      }
      throw new Error(err as string);
    }
  }

  const [validation, setValidation] = useState<HospitalBankValidation>({});
  return [validation, setValidation, handleValidation];
}
